import { render, staticRenderFns } from "./client-unit-therapies.vue?vue&type=template&id=638a8bac&scoped=true&lang=pug&"
import script from "./client-unit-therapies.vue?vue&type=script&lang=ts&"
export * from "./client-unit-therapies.vue?vue&type=script&lang=ts&"
import style0 from "./client-unit-therapies.vue?vue&type=style&index=0&id=638a8bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a8bac",
  null
  
)

export default component.exports